import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useCurrentOrganizationMembers } from "@api/organizationMember.api";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const TemplateOwnerFilterLabel: React.FC<Props> = ({ filters }) => {
    const { data: members } = useCurrentOrganizationMembers();
    const { closeTemplateOwnerIds } = filters;

    const labels = useMemo(
        () =>
            members
                ?.filter((member) =>
                    closeTemplateOwnerIds?.includes(member.user.id),
                )
                .map((member) => member.user.name) ?? [],
        [members, closeTemplateOwnerIds],
    );

    if (!closeTemplateOwnerIds || closeTemplateOwnerIds.length === 0) {
        return null;
    }

    return formatFilterLabel(labels);
};
